import cardsSvg from '@plone/volto/icons/cards.svg';
import Edit from './Edit';
import View from './View';

export const juntsCardBlock = {
  id: 'junts_cards',
  title: 'Junts Card',
  icon: cardsSvg,
  group: 'common',
  view: View,
  edit: Edit,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1,
  blockHasOwnFocusManagement: true,
};
